(function(){
  function sku(v){ return String(v || '').trim().toUpperCase(); }
  function norm(v){ return String(v || '').toLowerCase().replace(/[()–—/_.,-]/g,' ').replace(/\s+/g,' ').trim(); }

  function apply(root){
    if (!root) return;
    const parts = window.TJAT100Parts || [];
    const browser = root.querySelector('[data-t100-browser]');
    if (browser && !document.getElementById('t100-visual-lookup')) browser.id = 't100-visual-lookup';

    const originalOrder = new Map(parts.map(function(p,i){ return [p,i]; }));
    function searchScore(p, q){
      const raw = String(q || '').trim().toLowerCase();
      const nq = norm(q);
      const materialRaw = String(p.m || '').trim().toLowerCase();
      const material = norm(p.m);
      const name = norm(p.n);
      const assemblyName = norm(p.a);
      const groupName = norm(({spray:'Spray System',spread:'Spreading System',frame:'Airframe & Propulsion',lift:'Dual-Battery Lift'})[p.g] || p.g);
      const item = norm(p.i);
      let score = 0;
      if (!nq) return score;
      if (materialRaw === raw || material === nq) score += 1000;
      else if (materialRaw.startsWith(raw) || material.startsWith(nq)) score += 700;
      else if (materialRaw.includes(raw) || material.includes(nq)) score += 500;
      if (name === nq) score += 400;
      else if (name.startsWith(nq)) score += 250;
      else if (name.includes(nq)) score += 150;
      if (assemblyName === nq) score += 80;
      else if (assemblyName.includes(nq)) score += 40;
      if (groupName.includes(nq)) score += 20;
      if (item === nq) score += 10;
      return score;
    }
    function sortFor(term){
      const q = String(term || '').trim();
      if (!q) {
        parts.sort(function(a,b){ return (originalOrder.get(a) || 0) - (originalOrder.get(b) || 0); });
        return;
      }
      parts.sort(function(a,b){
        const diff = searchScore(b,q) - searchScore(a,q);
        if (diff) return diff;
        const nameDiff = norm(a.n).localeCompare(norm(b.n));
        if (nameDiff) return nameDiff;
        return norm(a.m).localeCompare(norm(b.m));
      });
    }

    const context = root.querySelector('[data-t100-diagram-sub]');
    let defaultContext = context ? context.textContent : '';

    function updateSharedCallouts(){
      const selectedRow = root.querySelector('[data-part-row].is-selected');
      const layers = [root.querySelector('[data-t100-hotspots]'), root.querySelector('[data-t100-modal-hotspots]')].filter(Boolean);
      layers.forEach(function(layer){
        layer.querySelectorAll('[data-hotspot-item]').forEach(function(btn){ btn.classList.remove('is-shared-selected'); });
      });

      if (!selectedRow) {
        if (context && context.dataset.sharedSummary === 'true') {
          context.textContent = defaultContext;
          delete context.dataset.sharedSummary;
        } else if (context) {
          defaultContext = context.textContent;
        }
        return;
      }

      const group = selectedRow.dataset.group || '';
      const assembly = selectedRow.dataset.assembly || '';
      const materialNode = selectedRow.querySelector('.t100parts__material');
      const selectedSku = sku(materialNode && materialNode.textContent);
      if (!selectedSku) return;

      const matches = [];
      const normalLayer = root.querySelector('[data-t100-hotspots]');
      if (normalLayer) {
        normalLayer.querySelectorAll('[data-hotspot-item]').forEach(function(btn){
          const item = btn.dataset.hotspotItem;
          const part = parts.find(function(p){ return p.g === group && p.a === assembly && String(p.i) === String(item); });
          if (part && sku(part.m) === selectedSku) matches.push(String(item));
        });
      }

      layers.forEach(function(layer){
        layer.querySelectorAll('[data-hotspot-item]').forEach(function(btn){
          const item = btn.dataset.hotspotItem;
          const part = parts.find(function(p){ return p.g === group && p.a === assembly && String(p.i) === String(item); });
          if (part && sku(part.m) === selectedSku) btn.classList.add('is-shared-selected');
        });
      });

      if (context && matches.length) {
        const uniqueMatches = [...new Set(matches)];
        context.textContent = selectedSku + ' is used at callout' + (uniqueMatches.length > 1 ? 's ' : ' ') + uniqueMatches.map(function(i){ return '#' + i; }).join(' and ') + ' on this diagram. Yellow markers show every matching location.';
        context.dataset.sharedSummary = 'true';
      }
    }

    const rows = root.querySelector('[data-t100-rows]');
    const normalHotspots = root.querySelector('[data-t100-hotspots]');
    const modalHotspots = root.querySelector('[data-t100-modal-hotspots]');
    const search = root.querySelector('.t100parts__search');
    const empty = root.querySelector('[data-t100-empty]');
    let emptyRequest = null;

    if (empty) {
      emptyRequest = document.createElement('a');
      emptyRequest.className = 't100parts__emptyRequest';
      emptyRequest.setAttribute('data-t100-empty-request','');
      emptyRequest.hidden = true;
      empty.appendChild(emptyRequest);
    }

    function updateEmptyRequest(){
      if (!emptyRequest || !search) return;
      const term = search.value.trim();
      emptyRequest.hidden = !term;
      if (!term) return;
      const params = new URLSearchParams();
      params.set('part',term);
      params.set('name','T100 part lookup request');
      params.set('assembly','Search did not return a match');
      emptyRequest.href = '/pages/contact?' + params.toString();
      emptyRequest.textContent = 'Ask TJ Aerosense about “' + term + '”';
    }

    const observer = new MutationObserver(function(){ window.requestAnimationFrame(function(){ updateSharedCallouts(); updateEmptyRequest(); }); });
    [rows, normalHotspots, modalHotspots].filter(Boolean).forEach(function(node){ observer.observe(node,{childList:true,subtree:true}); });

    root.addEventListener('click', function(e){
      const example = e.target.closest('[data-t100-example]');
      if (example) sortFor(example.dataset.t100Example || '');
      if (e.target.closest('.t100parts__clear') || e.target.closest('[data-t100-exit-search]')) sortFor('');
      setTimeout(function(){ updateSharedCallouts(); updateEmptyRequest(); },0);
    }, true);

    const select = root.querySelector('[data-t100-assembly]');
    if (select) select.addEventListener('change', function(){ setTimeout(function(){ if (context) defaultContext = context.textContent; updateSharedCallouts(); },0); });
    if (search) search.addEventListener('input', function(){ sortFor(search.value); setTimeout(function(){ updateSharedCallouts(); updateEmptyRequest(); },0); }, true);

    const searchParams = new URLSearchParams(window.location.search);
    const requestedPart = searchParams.get('part') || searchParams.get('sku') || searchParams.get('q');
    if (requestedPart && search) {
      search.value = requestedPart;
      sortFor(requestedPart);
      search.dispatchEvent(new Event('input',{bubbles:true}));
      setTimeout(function(){ if (browser) browser.scrollIntoView({block:'start'}); },80);
    }
    updateSharedCallouts();
    updateEmptyRequest();
  }

  document.querySelectorAll('.t100parts[data-t100parts]').forEach(apply);
})();
